/* Read a text/event-stream body; calls onChunk(text) for each data payload, returns when done. Throws on `event: error`.
   Named events other than done/error are passed to onEvent(name, data). */
export async function readSse(resp, onChunk, { json = true, onEvent } = {}) {
  const reader = resp.body.getReader();
  const dec = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) return;
    buffer += dec.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop() || "";
    events.forEach((ev) => handleEvent(ev, onChunk, json, onEvent));
  }
}

function handleEvent(ev, onChunk, json, onEvent) {
  if (!ev || ev.startsWith("event: done")) return;
  if (ev.startsWith("event: error")) throw new Error("stream error");
  const line = ev.split("\n").filter((l) => l.startsWith("data: ")).map((l) => l.slice(6)).join("");
  if (ev.startsWith("event: ")) {
    const name = ev.slice(7, ev.indexOf("\n") === -1 ? undefined : ev.indexOf("\n")).trim();
    let data = line;
    try { data = JSON.parse(line); } catch { data = line; }
    onEvent?.(name, data);
    return;
  }
  if (!line || line === "[DONE]") return;
  if (!json) return onChunk(line);
  let chunk = line;
  try { chunk = JSON.parse(line); } catch { chunk = line; }
  return onChunk(typeof chunk === "string" ? chunk : String(chunk));
}
